import { render, staticRenderFns } from "./PregledPoste.vue?vue&type=template&id=b3a37606"
import script from "./PregledPoste.vue?vue&type=script&lang=js"
export * from "./PregledPoste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports